// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.
import $ from 'jquery';

global.$ = $
global.jQuery = $

require('webpack-jquery-ui');
require('webpack-jquery-ui/css');
global.toastr = require("toastr")
toastr.options = {
  "positionClass": "toast-bottom-right",
  "closeButton": true
}
toastr.options.fadeOut = 6000;

import Rails from "@rails/ujs";
import Turbolinks from "turbolinks";
import * as ActiveStorage from "@rails/activestorage";
import "channels";
import '@fortawesome/fontawesome-free/css/all.css';
// import "chartkick/chart.js"
// import Velocity from "velocity-animate";

Rails.start();
Turbolinks.start();
ActiveStorage.start();

const images = require.context("../images", true);
const imagePath = (name) => images(name, true);

// Bootstrap 5
import * as bootstrap from "bootstrap";
import "../stylesheets/application";
import "bootstrap-icons/font/bootstrap-icons.css";
import "animate.css";
import 'select2'
import 'select2/dist/css/select2.css'

require("trix");
// require("@rails/actiontext");


// function loadStimulusControllers() {
  // console.log('loaded')
import('controllers/index.js')
// }

// window.addEventListener('turbolinks:load', loadStimulusControllers);

document.addEventListener("stimulus-reflex:finalize", e => {
  if (e.detail.success === false) {
    console.warn("[StimulusReflex] Fallback prevented redirect", e.detail.error)
  }
})

document.addEventListener("turbolinks:load", function (event) {
  var popoverTriggerList = [].slice.call(
    document.querySelectorAll('[data-bs-toggle="popover"]')
  );
  var popoverList = popoverTriggerList.map(function (popoverTriggerEl) {
    return new bootstrap.Popover(popoverTriggerEl);
  });

  var tooltipTriggerList = [].slice.call(
    document.querySelectorAll('[data-bs-toggle="tooltip"]')
  );
  var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
    return new bootstrap.Tooltip(tooltipTriggerEl);
  });


  // Add dl, dt, and dd to the allowed HTML list
  var myDefaultAllowList = bootstrap.Tooltip.Default.allowList;

  // To allow table elements
  myDefaultAllowList.dl = [];
  myDefaultAllowList.dt = [];
  myDefaultAllowList.dd = [];

  $(function($) {
    let url = window.location.href.split('?')[0];
    $('.report-menu a').each(function() {
      if (this.href === url) {
        $(this).addClass('active');
        $(this).addClass('text-white');
      }
    });
  });

});
// End Bootstrap 5

//action text disable attachment 
document.addEventListener("trix-file-accept", (e) => {
  e.preventDefault();
})

$(document).mouseup(function(e) 
{
    var container = $(".price-class-dropdown");

    // if the target of the click isn't the container nor a descendant of the container
    if (!container.is(e.target) && container.has(e.target).length === 0) 
    {
        container.hide();
    }
});

$(window).on('load', function() {
  $('.vertical-scroll').each(function(i, element) {
    if($(element).find('.current_time').first().length > 0){
      $(element).scrollTop($(element).scrollTop() + $($(element).find('.current_time').first()).position().top - 100);
    }
  });
  $(function($) {
    let url = window.location.href.split('?')[0];
    $('.report-menu a').each(function() {
      if (this.href === url) {
        $(this).addClass('active');
        $(this).addClass('text-white');
      }
    });
  });
});

document.addEventListener("turbolinks:load", function() {
  $('.vertical-scroll').each(function(i, element) {
    if($(element).find('.current_time').first().length > 0){
      $(element).scrollTop($(element).scrollTop() + $($(element).find('.current_time').first()).position().top - 100);
    }
  });
  
  $(".golfer_filter_select2").on('select2:select', function (e) {
    let event = new Event('change', { bubbles: false });
    this.dispatchEvent(event);
    // console.log("hi")
  });
  
  $('.golfer_filter_select2').select2({
    placeholder: '',
    allowClear: true,
    allowClear: true,
    templateResult: templateResult,
    templateSelection: templateSelection
  });

  function templateResult(item, container) {
    return $('<span>' + item.text.replace('[br]', '<br/>') + '</span>');
  }

  function templateSelection(item, container) {
    return item.text.replace('[br]', '').replace(/<small>/g, '').replace(/<\/small>/g, '');
  }

}); // TODO: RC: Clean up the duplication

$( document ).ready(function() {

  var userAgent = window.navigator.userAgent;
  var iOSDevice = /iPad|iPhone|iPod/.test(userAgent);
  var notMacOS = !/Macintosh/.test(userAgent);

  if (iOSDevice && notMacOS) {
    document.body.classList.add('ios-device');
  }

  $(".golfer_filter_select2").on('select2:select', function (e) {
    let event = new Event('change', { bubbles: false });
    this.dispatchEvent(event);
    // console.log("hi")
  });

  $('.golfer_filter_select2').select2({
    placeholder: '',
    allowClear: true,
    allowClear: true,
    templateResult: templateResult,
    templateSelection: templateSelection
  });

  function templateResult(item, container) {
    return $('<span>' + item.text.replace('[br]', '<br/>') + '</span>');
  }

  function templateSelection(item, container) {
    return item.text.replace('[br]', '').replace(/<small>/g, '').replace(/<\/small>/g, '');
  }

  $(document).on('click', '.t-days', function(e) {

    $('.t-days').removeClass('bg-light');
    $('.t-days').addClass('bg-success');
    $('.t-days').addClass('text-light');
    let target = $(e.target).closest('a');
    target.find('.display-5').html("<div class='text-center'><div class='spinner-border me-auto text-dark' role='status' aria-hidden='true'></div></div>");
    target.find('.display-55').html("<div class='text-center'><div class='spinner-border me-auto text-dark' role='status' aria-hidden='true'></div></div>");
    // target.addClass('bg-light');
    target.removeClass('bg-success');
    target.addClass('text-dark');
  });
  $("a.starter-sheet").on('click', function() {
    $(".golf-course-dropdown button").click()
  });

  $(".group-play-btn").click(function(){
    $("#group-play-loading").removeClass("d-none");
  });
  $(".golf-play-container").click(function(){
    $("#group-play-loading").removeClass("d-none");
  });
  
});

const originalWebSocketClose = WebSocket.prototype.close
WebSocket.prototype.close = function () {
  if (this.readyState != WebSocket.CONNECTING) {
    originalWebSocketClose.apply(this, arguments)
  }
}

$(document).click(function(event) {
  var parentElement = $('#invoice-report-golfer-filter');
  // Check if the clicked element is outside the parent element
  
  if (parentElement && !parentElement.is(event.target) && !parentElement.has(event.target).length) {
    // Remove the class from the parent element if it exists
    parentElement.find('.dropdown-menu').removeClass('show');
  }

  if (parentElement && parentElement.find('input').is(event.target)) {
    // Add the class to the dropdown-menu
    parentElement.find('.dropdown-menu').addClass('show');
  }


  function handleDropdown(parentId, event) {
    var parentElement = $('#' + parentId);

    // Check if the clicked element is outside the parent element
    if (parentElement && !parentElement.is(event.target) && !parentElement.has(event.target).length) {
      // Remove the class from the parent element if it exists
      parentElement.find('.dropdown-menu').removeClass('show');
    }

    // Check if the clicked element is the input inside the parent element
    if (parentElement && parentElement.find('input').is(event.target)) {
      if (event.target.type != 'submit') {
        parentElement.find('.dropdown-menu').addClass('show');
      }
    }
  }

  // Usage for sub-accounts-filter
  handleDropdown('sub-accounts-filter', event);

  // Usage for golfer-search-filter
  handleDropdown('golfer-search-filter', event);

});